import { Component, Inject, forwardRef, OnInit, PLATFORM_ID, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NgAisInstantSearch } from 'angular-instantsearch';
import { connectRefinementList } from 'instantsearch.js/es/connectors';
import { CatalogWidgetDirective, IBaseItem } from '../catalog-widget';
import { ToggleFacets } from '@app/shared/components/catalog/services/filters.service';
import { I18nData } from '@app/core/i18n/services';
import { Observable } from 'rxjs';
import { ICountry } from '@app/interfaces/country.interface';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'vc-catalog-widget-locations-checkbox-list',
  templateUrl: './catalog-widget-locations-checkbox-list.component.html',
  styleUrls: ['./catalog-widget-locations-checkbox-list.component.scss', '../catalog-widgets.scss']
})
export class CatalogWidgetLocationsCheckboxListComponent extends CatalogWidgetDirective implements OnInit, OnChanges {
  state: {
    items: IBaseItem[];
    createURL: () => string;
    refine: (value: string) => void;
    searchForItems: (value: string) => void;
    isFormSearch: boolean;
    canRefine: boolean;
    widgetParams: { attributeName };
    canToggleShowMore: boolean;
    isShowingMore: boolean;
    toggleShowMore: () => {};
  };

  @Input()
  currentCountry: string;

  public toggleFacets = ToggleFacets;
  public searchText = '';
  public limitToDisplaySearch = 10;
  public homeCountry: string;
  public searchLocationInput = new FormControl('');

  constructor(
    @Inject(forwardRef(() => NgAisInstantSearch)) public instantSearchParent,
    @Inject(PLATFORM_ID) platformId: object,
    public i18nData: I18nData
  ) {
    super('CatalogWidgetCheckboxListComponent', platformId);
  }
  get searchPlaceholder(): string {
    return this.options.searchPlaceholder || 'CATALOG.FILTERS.SEARCH_PLACEHOLDER.DEFAULT';
  }
  getCountryName(iso: string): Observable<ICountry> {
    return this.i18nData.getCountryFromIso(iso);
  }

  // Returns list of Items that will be used to build the filters
  // TODO: This function is called whenever scrolling. Shouldn't be the case
  get items(): IBaseItem[] {
    const isHierarchical = this.options && this.options.isHierarchical;
    let facetName = null;

    if (this.options) {
      facetName = Array.isArray(this.options.facet) ? this.options.facet[0] : this.options.facet;
      if (ToggleFacets.indexOf(facetName) === -1) {
        facetName = null;
      }
    }

    // Merge duplicates
    const merged = this.isServer
      ? this.mergeSameLabels(this.transformItems(isHierarchical, facetName)).slice(0, 10)
      : this.mergeSameLabels(this.transformItems(isHierarchical, facetName));

    merged.map(a => {
      this.i18nData.getCountryFromIso(a.label).subscribe(
        b => {
          a.label = b.name;
        },
        _ => {
          // silent catch nothing to do
        }
      );
    });
    const newCountriesArray: IBaseItem[] = merged.sort((a, b) => a.label.localeCompare(b.label));
    return this.settHomeCountryOnTop(newCountriesArray, this.currentCountry);
  }

  ngOnInit() {
    let widgetConfig = {
      limit: this.options.limit,
      attributeName: this.options.facet,
      sortBy: this.options.sortBy ? this.options.sortBy : ['name:asc'],
      showMoreLimit: this.options.showMoreLimit,
      canToggleShowMore: true,
      isShowingMore: true
    };

    if (this.isServer && ['CATALOG.FILTERS.MODEL', 'CATALOG.FILTERS.MATERIALS'].indexOf(this.options.label) > -1) {
      widgetConfig = {
        ...widgetConfig,
        ...{
          canToggleShowMore: false,
          limit: 50,
          showMoreLimit: 50
        }
      };
    }

    this.createWidget(connectRefinementList, widgetConfig);
    super.ngOnInit();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.currentCountry) {
      this.currentCountry = changes.currentCountry.currentValue;
    }
    if (changes.pageRouteParameter) {
      if (!changes.pageRouteParameter.firstChange && this.searchLocationInput) {
        this.searchLocationInput.reset('');
        this.searchText = '';
      }
    }
  }

  /**
   * Return URl of Discount filter for SEO
   */
  get getDiscountUrl(): string {
    let result = null;
    if (this.isServer && this.facetLink && this.facetLink.editorPicks) {
      const found = this.facetLink.editorPicks.find(element => element.facetId === 'sale');
      if (found) {
        result = found.path;
      }
    }

    return result;
  }

  settHomeCountryOnTop(countries: IBaseItem[], homeCountry: string): IBaseItem[] {
    if (!countries) {
      return [];
    }
    if (!homeCountry || homeCountry === '') {
      return countries;
    }
    return countries.sort((x, y) => {
      return x.value === homeCountry ? -1 : y.value === homeCountry ? 1 : 0;
    });
  }
}
